import { loading, success, error } from 'State/actions';
import * as types from './types';

export const getAllergens = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.RECIPE_LISTING_LOADING), true);

      const response = await MPWWebApi.getGeneric('Allergen');

      dispatch(success(types.RECIPE_LISTING_GET_ALLERGENS, response.data.Data));
    } catch (exception) {
      dispatch(error(types.RECIPE_LISTING_GET_ALLERGENS_ERROR, exception));
    } finally {
      dispatch(loading(types.RECIPE_LISTING_LOADING, false));
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/recipelisting/state/report/actions.js